"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var EnumFilter_1 = require("./EnumFilter");
var messages_1 = require("../../messages");
/**
 * The BooleanFilter component used for editing boolean value of FilterDescriptor object.
 */
var BooleanFilter = /** @class */ (function (_super) {
    __extends(BooleanFilter, _super);
    function BooleanFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [{ text: messages_1.filterIsTrue, value: true }, { text: messages_1.filterIsFalse, value: false }];
        return _this;
    }
    /**
     * @hidden
     */
    BooleanFilter.prototype.render = function () {
        return (React.createElement(EnumFilter_1.EnumFilter, { filter: this.props.filter, onFilterChange: this.props.onFilterChange, data: this.props.data || this.data, defaultItem: this.props.defaultItem }));
    };
    /**
     * @hidden
     */
    BooleanFilter.propTypes = {
        filter: PropTypes.object.isRequired,
        onFilterChange: PropTypes.func.isRequired,
        data: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, value: PropTypes.any })),
        defaultItem: PropTypes.any
    };
    return BooleanFilter;
}(React.Component));
exports.BooleanFilter = BooleanFilter;
//# sourceMappingURL=BooleanFilter.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/filter/filters/BooleanFilter.js
// module id = 6485
// module chunks = 0